// extracted by mini-css-extract-plugin
module.exports = {"container":"FullInfo_container__2y5sM","attributes":"FullInfo_attributes__2I51M"};